// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react'; // eslint-disable-next-line
import { Card, CardBody, CardHeader, Collapse, Row, Col, Badge } from 'react-bootstrap'; // eslint-disable-next-line
import { copiriPortalRequest } from '../../api/api'; // eslint-disable-next-line
import config from '../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify'; // eslint-disable-next-line
const UserDegreeHistoryAccordionItem = ({
	data,
	active,
	onToggle,
	currentIndex,
	pageLanguageContent,
	profileId,
	memebrshipStatus,
	updateData
}) => {
	// eslint-disable-next-line
	const { id, member_number, name, role, seal, status_id, is_admin, checked, parent_id, status_text, conferred } = data;
	return (
		<>
			<Card className={'shadow-none border rounded-0 ' + (parent_id ? 'orgChildMember' : '')}>
				<CardHeader
					onClick={onToggle}
					className={`py-2 px-lg-3 px-0 border-none cursor-pointer ${
						active ? 'activeMemebrShipHeader' : 'deActiveMemebrShipHeader'
					}`}
				>
					<span className='font-weight-medium text-dark text-sans-serif pl-2'>{name}</span>
					<div className='openHideAccordian'>
						<span className={checked ? 'headerText' : ''}>
							{checked ? (
								<>
									{' '}
									{pageLanguageContent['PRL122'] ? pageLanguageContent['PRL122'] : ''}: {checked}{' '}
								</>
							) : (
								''
							)}
						</span>
						{/*<span className="trashIcon"><i className="far fa-trash-alt"></i></span>*/}
						<span className='updownArrow'>
							{active ? <i className='far fa-angle-up'></i> : <i className='far fa-angle-down'></i>}
						</span>
					</div>
				</CardHeader>
				<Collapse in={active}>
					<CardBody className='pt-3'>
						<div className='profile-card-membership'>
							<Row>
								<Col lg={2} className='pc-ms-border-right1'>
									<strong>{pageLanguageContent['PRL168'] ? pageLanguageContent['PRL168'] : ''}:</strong>
								</Col>
								<Col lg={4} className='pc-ms-border-right1'>
									{name}
								</Col>
								<Col lg={6} className='text-right'>
									{conferred}
								</Col>
							</Row>
						</div>
					</CardBody>
				</Collapse>
			</Card>
		</>
	);
};

export default UserDegreeHistoryAccordionItem;
